var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "backtotop",
    class: {
      offscreen: !_vm.show
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('mdm-icon', {
    attrs: {
      "size": "20",
      "name": "chevron-top-slim"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };